// extracted by mini-css-extract-plugin
module.exports = {"label":"_2sCYoZ19gRoj5qeHqaVwNP","settingsRow":"_2PJc4hJfGpo2TN6sNxF5HF","dropZoneImage":"_1gJNDLGI8MnMdrNdlu3P0b","btnWrap":"_2G5bTTpfG2xAmmoZGl7bKy"};